import React from "react";
import { ApplicationState } from "../../../store/stores/ApplicationState";
import { ThemedButton } from "../../inputs/buttons/ThemedButton";
import { Link, Route, Routes } from "react-router-dom";
import { Loader } from "../../theming/loader/Loader";
import { ErrorNotification } from "../../notifications/Notification";
import { AdventureCreator } from "./AdventureCreator";
import { useAppSelector } from "../../../store/configureStore";

export const AdventureList: React.FC = () => {
    const { adventures, loaded, error } = useAppSelector((state: ApplicationState) => state.adventure);
    const loadCompleted = loaded && !error;
    let unnamedAdventureCount = 0;
    return (
        <>
            <h1>My Adventures</h1>
            {loadCompleted && <div>
                <Link to="/Adventures/Create"><ThemedButton disabled={false}>Create New Adventure</ThemedButton></Link>
                <Routes>
                    <Route path="Create" element={<AdventureCreator />} />
                </Routes>
            </div>}

            {loadCompleted && !adventures.any() && "You're not participating in any adventures yet!"}
            {!loaded && !error && <Loader size="XL">Loading Adventures</Loader>}
            {error && <ErrorNotification>There was an error loading your adventures, you can try refreshing the page to fix the issue.</ErrorNotification>}
            <ul className="owned-list">
                {adventures.map(adventure => {
                    const name = adventure.name.trim() == ''
                        ? `Unnamed Adventure ${++unnamedAdventureCount}`
                        : adventure.name;
                    return (
                        <li key={adventure.id}>
                            <Link key={adventure.id} to={`/Adventures/${adventure.id}/View`}>
                                {name}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </>
    );
}